import AppDataService from "./AppDataService";
const XERO_COMMON_BASE = 'Xero';
const FRSHBOOKS_COMMON_BASE = 'FreshBook';
const QBO_COMMON_BASE = 'QBO';
const QBD_COMMON_BASE = 'Qbd';
const INTEGRATION_COMMON_BASE = 'IntegrationHelper';
const ZOHO_COMMON_BASE = 'Zoho';
const TIPALTI_COMMON_BASE = 'Tipalti';
const BILL_COMMON_BASE = 'Bill';
const ENTRATA_COMMON_BASE = 'Entrata';
const ACCOUNTINGSUITE_COMMON_BASE = 'AccountingSuite';

export default class IntegrationDataService {
    static async index() {
        return await AppDataService.post(`${XERO_COMMON_BASE}/Index`);
    }
    static async connectXero(params) {
        return await AppDataService.get(`${XERO_COMMON_BASE}/ConnectXero`, { params });
    }
    static async disconnectXero(params) {
        return await AppDataService.get(`${XERO_COMMON_BASE}/DisconnectAsync`, { params });
    }
    static async getIntegrationImportData(integrationImportRequestDto) {
        return await AppDataService.post(`${INTEGRATION_COMMON_BASE}/GetIntegrationImportData`, integrationImportRequestDto);
    }
    static async getTaxYearFormTypes() {
        return await AppDataService.get(`${INTEGRATION_COMMON_BASE}/GetTaxYearFormTypes`);
    }
    static async freshbooksIndex() {
        return await AppDataService.post(`${FRSHBOOKS_COMMON_BASE}/Index`);
    }
    static async connectToFreshBooks(params) {
        return await AppDataService.get(`${FRSHBOOKS_COMMON_BASE}/ConnectFreshBooks`, { params });
    }
    static async qboIndex() {
        return await AppDataService.get(`${QBO_COMMON_BASE}/Index`);
    }
    static async connectToQbo(params) {
        return await AppDataService.post(`${QBO_COMMON_BASE}/ConnectQBO`, params);
    }
    static async disconnectQbo(params) {
        return await AppDataService.post(`${QBO_COMMON_BASE}/DisconnectAsync?realmId=${params}`);
    }
    static async getCOATypes(qboRequestDto) {
        return await AppDataService.post(`${QBO_COMMON_BASE}/GetChartOfAccounts`, qboRequestDto);
    }
    static async getFormLabels() {
        return await AppDataService.get(`${INTEGRATION_COMMON_BASE}/GetFormLabels`);
    }
    static async uploadFileData(formData) {
        return await AppDataService.post(`${INTEGRATION_COMMON_BASE}/UploadData`, formData);
    }
    static async qbWebConnectorUserLogin(payerId) {
        return await AppDataService.post(`${QBD_COMMON_BASE}/QBWebConnectorUserLogin?PayerId=${payerId}`);
    }
    static async handleWebConnectorSyncConfirmationEmail() {
        return await AppDataService.get(`${QBD_COMMON_BASE}/HandleWebConnectorSyncConfirmationEmail`);
    }
    static async qBWebConnectorDownload() {
        return await AppDataService.get(`${QBD_COMMON_BASE}/QBWebConnectorDownload`);
    }
    static async qbPlugInDownload() {
        return await AppDataService.get(`${QBD_COMMON_BASE}/QBPlugInDownload`);
    }
    static async ZohoUrl() {
        return await AppDataService.post(`${ZOHO_COMMON_BASE}/Index`);
    }
    static async connectZoho(params) {
        return await AppDataService.get(`${ZOHO_COMMON_BASE}/ConnectZoho`, { params });
    }
    static async getRedirectUrl() {
        return await AppDataService.get(`${TIPALTI_COMMON_BASE}/getTipaltiRedirectUrl`);
    }
    static async tipaltiTokenUpdate(params) {
        return await AppDataService.post(`${TIPALTI_COMMON_BASE}/ProcessTipaltiTokenUpdate`, params);
    }
    static async payerEntityFilters(payerId) {
        return await AppDataService.get(`${TIPALTI_COMMON_BASE}/PayerEntityFilters?PayerId=${payerId}`);
    }
    static async getTipaltiLoadOrImportData(params) {
        return await AppDataService.post(`${TIPALTI_COMMON_BASE}/GetTipaltiLoadOrImportData`, params);
    }
    static async getOrganizations(billModel) {
        return await AppDataService.post(`${BILL_COMMON_BASE}/GetOrganization`, billModel);
    }
    static async getBillOrgDetailsByUser() {
        return await AppDataService.post(`${BILL_COMMON_BASE}/GetBillOrgDetailsByUser`);
    }
    static async disconnectFreshBooks(params) {
        return await AppDataService.get(`${FRSHBOOKS_COMMON_BASE}/DisconnectAsync`, { params });
    }
    static async connectToEntrata() {
        return await AppDataService.get(`${ENTRATA_COMMON_BASE}/ConnectEntrata`);
    }
    static async getAccountingSuiteUrl() {
        return await AppDataService.post(`${ACCOUNTINGSUITE_COMMON_BASE}/Index`);
    }
    static async GetOrganizationDetails(params) {
        return await AppDataService.get(`${ACCOUNTINGSUITE_COMMON_BASE}/GetOrganizationDetails`, {params});
    }
    static async disconnectAccountingSuite(params) {
        return await AppDataService.get(`${ACCOUNTINGSUITE_COMMON_BASE}/DisconnectAsync`, {params});
    }

    static async updateQbInactiveVendor(InactiveVendorsModel) {
        return await AppDataService.post(`${QBD_COMMON_BASE}/UpdateInactiveVendor`, InactiveVendorsModel);
    }
    static async getIsInactiveVendors() {
        return await AppDataService.get(`${QBD_COMMON_BASE}/GetIsInactiveVendors`);
    }
}
